export const HelperText = ({ text, centered = false }) => {
  if (text)
    return (
      <p className={`font11 lightColor thin ${centered && "textCenter"}`}>
        {text}
      </p>
    );
};
